module.exports = __webpack_public_path__ + "static/media/bgImage@2x.5915070e.jpg";